import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import MediaFrame from "../components/MediaFrame";
import Reveal from "../components/Reveal";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [artists, setArtists] = useState([]);
  const [cat, setCat] = useState("Tout");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {});
  }, []);

  const artistName = (id) => artists.find((a) => a.id === id)?.name || "Joy Messenger";
  const categories = useMemo(() => ["Tout", ...new Set(products.map((p) => p.category))], [products]);
  const filtered = useMemo(() => (cat === "Tout" ? products : products.filter((p) => p.category === cat)), [products, cat]);

  return (
    <main data-testid="shop-page" className="pt-28 sm:pt-36">
      <div className="jm-container pb-24 sm:pb-32">
        <Reveal>
          <p className="jm-overline mb-5">Boutique</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-jm-bone leading-[1.08]">
            Objets, disques & éditions
          </h1>
          <p className="mt-6 max-w-2xl text-jm-smoke leading-relaxed">
            Vinyles, CD, téléchargements, affiches et textiles — chaque achat soutient directement les projets
            de la maison. Le paiement en ligne arrive bientôt ; en attendant, précommandes et réservations se font
            par simple message.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          {categories.length > 2 && (
          <div className="mt-12 flex flex-wrap gap-2.5" data-testid="shop-categories">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`shop-cat-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
                onClick={() => setCat(c)}
                className={`px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] border transition-colors duration-300 ${
                  cat === c ? "border-jm-amber bg-jm-amber text-jm-ink" : "border-jm-brass/25 text-jm-smoke hover:text-jm-bone"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          )}
        </Reveal>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6" data-testid="products-grid">
          {filtered.length === 0 && (
            <p className="col-span-full py-12 text-jm-mute text-sm">Aucun objet dans cette catégorie pour le moment.</p>
          )}
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={0.06 * (i % 4)}>
              <Link to={`/boutique/${p.id}`} data-testid={`shop-product-${p.id}`} className="group block">
                <div className="relative overflow-hidden border border-jm-brass/15 group-hover:border-jm-brass/40 transition-colors duration-500">
                  <div className="aspect-square transition-transform duration-[1100ms] ease-out group-hover:scale-[1.04]">
                    <MediaFrame label={p.category} sublabel={artistName(p.artist)} accent="#C5A059" image={p.image} className="w-full h-full" />
                  </div>
                  {p.badge && (
                    <span className="absolute top-3 left-3 bg-jm-amber text-jm-ink font-mono text-[9px] uppercase tracking-[0.18em] px-2.5 py-1">
                      {p.badge}
                    </span>
                  )}
                </div>
                <div className="pt-4 flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <h2 className="font-serif text-base sm:text-lg text-jm-bone leading-snug group-hover:text-jm-brass transition-colors duration-300">
                      {p.name}
                    </h2>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-jm-mute mt-1.5">{artistName(p.artist)}</p>
                  </div>
                  <span className="shrink-0 font-mono text-sm text-jm-brass">{p.price} €</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
